var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:['divider-container', {'-vertical': _vm.vertical}],style:({margin: _vm.marginValue})},[_c('div',{ref:"indicator",class:['divider-line', {'-full': _vm.full}, {'-show': _vm.show}, {'-faded': _vm.hideLine}]},[(_vm.text && !_vm.vertical)?_c('span',{ref:"text",staticClass:"divider-text"},[_vm._v(_vm._s(_vm.text))]):_vm._e()])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f1269440","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Divider/Divider.vue
// module id = null
// module chunks = 